import { z } from '@harvestiq/zod';
import { getFaqByIdParamsSchema } from './get-faq-by-id-schema';

export const deleteFaqRequestParamsSchema = getFaqByIdParamsSchema;

export type DeleteFaqRequestParams = z.infer<
  typeof deleteFaqRequestParamsSchema
>;

export const deleteFaqResponseSchema = z.object({
  success: z.boolean(),
});

export type DeleteFaqResponse = z.infer<typeof deleteFaqResponseSchema>;
